export default {
    namespaced: true,
    state: {
        colourSelection: '',
        dimensions: {},
        raxisSelection: '',
        type: 'bubble',
        visiblePoints: [],
        xAxisSelection: '',
        yAxisSelection: '',
        tooltipSelection: 'General',
        selectedFund: {},
    },
    mutations: {
        updateVisiblePoints (state, data) {
            state.visiblePoints = data;
        },
        updateChartType (state, type) {
            state.type = type;
        },
        updateDimensions (state, dimensions) {
            state.dimensions = dimensions;
        },
        updateXaxisSelection (state, updateData) {
            state.xAxisSelection = updateData;
        },
        updateYaxisSelection (state, updateData) {
            state.yAxisSelection = updateData;
        },
        updateRaxisSelection (state, updateData) {
            state.raxisSelection = updateData;
        },
        updateColourSelection (state, updateData) {
            state.colourSelection = updateData;
        },
        updateTooltipSelection (state, updateData) {
            state.tooltipSelection = updateData;
        },
        updateSelectedFund (state, fund) {
            state.selectedFund = fund;
        },
    },
};
